<template>
  <div class="bottom-wrap">
    <img
      src="https://djqsmiqswxrv8.cloudfront.net/joy2ever/web/bottom.png"
      class="img-bottom"
      alt=""
    />
    <div class="bottom-contact">
      <span class="contact-title">Contact</span>
      <div class="contact-email">spookymerge-support@joy2ever.com</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Bottom',
};
</script>

<style lang="less" scoped>
.bottom-wrap {
  position: relative;
  width: 100%;
}

.img-bottom {
  display: block;
  width: 100%;
  height: 100px;
}

.bottom-contact {
  position: absolute;
  left: 50%;
  top: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  min-width: 420px;
  padding: 14px 36px;
  color: #e5ca8a;
  background: rgba(6, 6, 30, 0.58);
  border: 1px solid rgba(229, 202, 138, 0.32);
  border-radius: 999px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.28);
  transform: translate(-50%, -50%);
}

.contact-title {
  position: relative;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 3px;
  text-transform: uppercase;
}

.contact-title::after {
  content: "";
  position: absolute;
  top: 50%;
  right: -14px;
  width: 1px;
  height: 18px;
  background: rgba(229, 202, 138, 0.38);
  transform: translateY(-50%);
}

.contact-email {
  color: #f4dfaa;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 1px;
  text-decoration: none;
  transition: color 0.25s ease, text-shadow 0.25s ease;
}

.contact-email:hover {
  color: #ffffff;
  text-shadow: 0 0 10px rgba(229, 202, 138, 0.7);
}

@media screen and (max-width: 750px) {
  .bottom-wrap {
    margin-top: 120px;
  }

  .bottom-contact {
    min-width: 0;
    width: 78%;
    flex-direction: column;
    gap: 6px;
    padding: 12px 18px;
    border-radius: 22px;
  }

  .contact-title {
    font-size: 13px;
    letter-spacing: 2px;
  }

  .contact-title::after {
    display: none;
  }

  .contact-email {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Bottom.vue